import React, { useState, useEffect, useRef } from "react";

import TableHeader from "../../../../../components/Table/Header";
import ModalListaUsuarios from "../../../../../components/ModalListaUsuarios";
import addMore from "../../../../../assets/icons/addMore.png";
import less from "../../../../../assets/icons/less.png";
import { trackPromise } from "react-promise-tracker";
import { obterPermissaoInfo } from "../../../../../services/http/permissaoServico";
import "./styles.scss";
import { Checkbox } from "antd";

const PermissoesUsuarios = ({
  setUsuariosPermissao,
  usuariosComPermissao,
  setUsuariosRemovidos,
  idPermissaoEdicao,
}) => {
  const [modalUsuarios, setModalUsuarios] = useState(false);

  const showModalUsuarios = () => {
    setModalUsuarios(true);
  };
  const closeModalUsuarios = () => {
    setModalUsuarios(false);
  };

  const removerUsuarios = () => {
    var u = [];
    var v = [];
    usuariosComPermissao.map((x) => {
      if (!x.checked) {
        u.push(x);
      } else {
        v.push(x);
      }
    });
    setUsuariosPermissao(u);
    setUsuariosRemovidos(v);
  };

  const marcarRemovertodos = (checked) => {
    var u = [];

    usuariosComPermissao.map((x) => {
      checked ? (x.checked = true) : (x.checked = false);
      u.push(x);
    });

    setUsuariosPermissao(u);
  };
  useEffect(() => {
    var u = [];
    usuariosComPermissao.map((x) => {
      x.checked = false;
      u.push(x);
    });
    setUsuariosPermissao(u);
  }, []);
  const adicionarOuRemoverUsuario = (value) => {
    var u = [];

    usuariosComPermissao.map((x) => {
      if (x.id === value.id) {
        x.checked ? (x.checked = false) : (x.checked = true);
        u.push(x);
      } else {
        u.push(x);
      }
    });

    setUsuariosPermissao(u);
  };

  return (
    <div>
      <div className="row" style={{ borderBottom: "1px solid #898989" }}>
        <div
          style={{ padding: "0px" }}
          className="col-md-7 col-sm-7 col-xl-7 mb-3"
        >
          <span className="titulosPermissoesNotificacoes">
            Usuários com esta permissão
          </span>
        </div>

        <div className="col-md-5 col-sm-5 col-xl-5">
          <span
            onClick={() => showModalUsuarios()}
            className="destinatario mr-3"
          >
            <img src={addMore}></img> Adicionar usuário
          </span>
          <span onClick={() => removerUsuarios()} className="destinatario">
            <img src={less}></img> Excluir usuário
          </span>
        </div>
      </div>

      <div
        className="row"
        style={{
          height: `${usuariosComPermissao?.length > 7 ? "300px" : ""}`,
          overflow: `${usuariosComPermissao?.length > 7 ? "auto" : ""}`,
        }}
      >
        <table className="table table-borderless col-lg-12 mt-3">
          <TableHeader
            columns={[
              <Checkbox
                onClick={(event) => marcarRemovertodos(event.target.checked)}
              />,
              "Nome",
              "Login",
              "E-mail",
              "Nivel de acesso",
            ]}
          />
          <tbody>
            {usuariosComPermissao.map((item, index) => (
              <tr key={index}>
                <td>
                  <span>
                    <Checkbox
                      style={{ marginTop: "-9px" }}
                      checked={item.checked}
                      onClick={(event) => adicionarOuRemoverUsuario(item)}
                    />
                  </span>
                </td>
                <td>
                  <span className="coluna-nome">
                    <span>{item.nome}</span>
                  </span>
                </td>
                <td> {item.login} </td>
                <td> {item.email} </td>
                <td> {item.nivelAcesso} </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modalUsuarios === true && (
        <ModalListaUsuarios
          closeModal={closeModalUsuarios}
          usuarios={usuariosComPermissao}
          setUsuarios={setUsuariosPermissao}
          openModal={modalUsuarios}
        />
      )}
    </div>
  );
};

export default PermissoesUsuarios;
